//client.js
const OSS = require('ali-oss');//引入oss
import { get_sts } from '@/api'//获取sts账号的api 用于登录oss
/**
 * 
 * @param {string} file_path  上传到oss目录路径
 * @param {string} file_name  上传文件名
 * @param {file} file         文件
 */
export async function upload_images_oss (file_path, file_name, file) {
  console.log("upload_images_oss",file_path, file_name, file)
  let file_name_arr = file_name.split('.')
  let upload_file_name = `${file_name_arr[0]}${Date.now()}.${file_name_arr[1]}`//这边是给文件名字后加时间戳 避免图片名字一样 照成图片覆盖
  
  let res = await get_sts()//接口数据获取
  let sts_account = res.data.credentials
  console.log('get_sts0',res)
  let client = new OSS({
    region: 'oss-cn-hangzhou',//这个可能和我不一样 后端反你 你就用后端反你的region
    accessKeyId: sts_account.accessKeyId,
    accessKeySecret: sts_account.accessKeySecret,
    stsToken: sts_account.securityToken,
    bucket: 'puietel-software',//bucket 可以理解为仓库  那么websrc就是oss根目录下的一个仓库名字
    timeout:200000,//超时时间 默认60S 自行设置
  })
 
  try {
  	//put上传方法     第一个参数文件名，   第二个参数文件
  	//如果指定目录的话 第一个参数可以写成 目录名/文件名  那么图片就会被上传到websrc/目录名/文件名  下 
    // let params = new FormData()
    // params.append('file', file) 
    // console.log("params",params)
    // // let reader = new FileReader();
    // //读取文件流
    // reader.readAsArrayBuffer(file);
    // console.log("reader",reader)
    let result = await client.put(`${file_path}${file_name}`, file);
    return result
  } catch (e) {
    console.log(e);
  }
}



// WEBPACK FOOTER //
// ./src/utils/client.js